/* ============================================================
   HALOS & EARTH — Shopify theme JS
   Cart via AJAX Cart API + Section Rendering API
   ============================================================ */
(function () {
  'use strict';
  var routes = (window.HALOS && window.HALOS.routes) || {
    cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart'
  };

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- drawer ---------- */
  function openDrawer() {
    var d = $('#cart-drawer'), o = $('#overlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = $('#cart-drawer'), o = $('#overlay');
    if (d) d.classList.remove('open');
    if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    if (!t) { t = document.createElement('div'); t.id = 'toast'; t.className = 'toast'; document.body.appendChild(t); }
    t.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg><span>' + msg + '</span>';
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- re-render the cart drawer section + count ---------- */
  function refreshCart(openAfter, addedTitle) {
    // Fetch the cart drawer section HTML and the cart JSON in parallel
    Promise.all([
      fetch('?section_id=cart-drawer').then(function (r) { return r.text(); }),
      fetch(routes.cart + '.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var html = res[0], cart = res[1];
      // Swap drawer inner content
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var fresh = temp.querySelector('#cart-drawer');
      var current = $('#cart-drawer');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      // Update header count(s)
      updateCount(cart.item_count);
      if (addedTitle) toast(addedTitle + ' added');
      if (openAfter) openDrawer();
    }).catch(function () { window.location.href = routes.cart; });
  }

  function updateCount(n) {
    $all('.cart-count').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-empty', n === 0 ? 'true' : 'false');
    });
  }

  /* ---------- currency display switcher (PKR / USD) ---------- */
  function setCurrency(cur) {
    document.documentElement.classList.toggle('cur-usd', cur === 'USD');
    try { localStorage.setItem('halos_currency', cur); } catch (e) {}
    $all('.cur-toggle button').forEach(function (b) {
      b.classList.toggle('active', b.getAttribute('data-cur') === cur);
    });
  }
  function initCurrency() {
    var saved = 'PKR';
    try { saved = localStorage.getItem('halos_currency') || 'PKR'; } catch (e) {}
    setCurrency(saved);
  }

  /* ---------- cart mutations ---------- */
  function addToCart(variantId, qty, title) {
    if (!variantId) return;
    fetch(routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { toast(data.description || 'Could not add to cart'); return; }
        refreshCart(true, title);
      }).catch(function () { toast('Could not add to cart'); });
  }

  function changeQty(key, qty) {
    fetch(routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function () { refreshCart(false); })
      .catch(function () { window.location.href = routes.cart; });
  }

  /* ---------- opt-in delivery location -> cart attribute ---------- */
  function shareLocation(btn) {
    if (!navigator.geolocation) { toast('Location not supported on this device'); return; }
    var original = btn.innerHTML;
    btn.disabled = true; btn.style.opacity = '0.6'; btn.innerHTML = 'Locating…';
    navigator.geolocation.getCurrentPosition(function (pos) {
      var lat = pos.coords.latitude.toFixed(6), lng = pos.coords.longitude.toFixed(6);
      var acc = Math.round(pos.coords.accuracy || 0);
      var mapsUrl = 'https://maps.google.com/?q=' + lat + ',' + lng;
      fetch(routes.cart + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'Delivery location': mapsUrl, 'Location accuracy (m)': String(acc) } })
      }).then(function (r) { return r.json(); })
        .then(function () {
          toast('Location attached');
          var wrap = btn.closest('[data-loc-wrap]') || btn.parentNode;
          wrap.innerHTML = '<p style="font-size:12px;color:var(--ink);margin:0;display:flex;align-items:center;gap:6px;flex-wrap:wrap">' +
            '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 21s-7-6.5-7-11a7 7 0 0 1 14 0c0 4.5-7 11-7 11Z"></path><circle cx="12" cy="10" r="2.5"></circle></svg>' +
            'Delivery location attached · <a href="' + mapsUrl + '" target="_blank" rel="noopener" style="text-decoration:underline">view pin</a></p>';
        })
        .catch(function () { btn.disabled = false; btn.style.opacity = ''; btn.innerHTML = original; toast('Could not save location'); });
    }, function (err) {
      btn.disabled = false; btn.style.opacity = ''; btn.innerHTML = original;
      toast(err && err.code === 1 ? 'Location permission denied' : 'Could not get location');
    }, { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 });
  }

  /* ---------- event delegation ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      var qtyInput = add.closest('[data-product-form]') ? $('[data-qty-value]', add.closest('[data-product-form]')) : null;
      var q = qtyInput ? parseInt(qtyInput.textContent, 10) || 1 : 1;
      addToCart(add.getAttribute('data-variant-id'), q, add.getAttribute('data-title'));
      return;
    }
    var qbtn = e.target.closest('[data-qty]');
    if (qbtn && qbtn.getAttribute('data-key')) {
      e.preventDefault();
      changeQty(qbtn.getAttribute('data-key'), parseInt(qbtn.getAttribute('data-q'), 10));
      return;
    }
    var locBtn = e.target.closest('[data-share-location]');
    if (locBtn) { e.preventDefault(); shareLocation(locBtn); return; }
    var curBtn = e.target.closest('[data-cur]');
    if (curBtn) { setCurrency(curBtn.getAttribute('data-cur')); return; }
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeDrawer(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); var m = $('#mobile-menu'); if (m) m.classList.remove('open'); document.body.style.overflow = ''; }
  });

  /* ---------- product page: qty stepper + gallery ---------- */
  function initProduct() {
    var form = $('[data-product-form]');
    if (form) {
      var val = $('[data-qty-value]', form);
      $all('[data-qty-step]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var cur = parseInt(val.textContent, 10) || 1;
          cur = Math.max(1, cur + parseInt(b.getAttribute('data-qty-step'), 10));
          val.textContent = cur;
        });
      });
    }
    $all('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var main = $('#pdp-main');
        if (main) main.src = btn.getAttribute('data-img');
        $all('[data-thumb]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  /* ---------- sticky mobile add-to-cart ---------- */
  function initStickyAtc() {
    var bar = $('#sticky-atc');
    var anchor = $('#pdp-add');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // show only once the buy button has scrolled up out of view
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('show', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      document.body.classList.toggle('atc-visible', past);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- accordion ---------- */
  function initAccordion() {
    $all('.acc__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var a = btn.nextElementSibling;
        var open = a.style.maxHeight && a.style.maxHeight !== '0px';
        a.style.maxHeight = open ? '0px' : a.scrollHeight + 'px';
        var sign = btn.querySelector('.sign'); if (sign) sign.textContent = open ? '+' : '–';
      });
    });
  }

  /* ---------- header scroll + mobile menu + reveal ---------- */
  function initChrome() {
    var header = $('.header');
    function onScroll() { if (header) header.classList.toggle('scrolled', window.scrollY > 20); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var burger = $('#burger'), menu = $('#mobile-menu');
    if (burger && menu) {
      burger.addEventListener('click', function () {
        var open = menu.classList.toggle('open');
        document.body.style.overflow = open ? 'hidden' : '';
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      $all('a', menu).forEach(function (a) {
        a.addEventListener('click', function () { menu.classList.remove('open'); document.body.style.overflow = ''; });
      });
    }
  }

  function observeReveal() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $all('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initChrome();
    observeReveal();
    initProduct();
    initAccordion();
    initCurrency();
    initStickyAtc();
  });
})();
